import { Component, OnInit } from '@angular/core';
import { AuthKeyService } from "../../services/auth-key.service";
import { ModalController } from "@ionic/angular/standalone";
import { IonHeader, IonToolbar, IonBackButton, IonTitle, IonContent, IonIcon } from "@ionic/angular/standalone";
import { GenerateKeyComponent } from "../../components/generate-key/generate-key.component";
import { AuthKey } from "../../model/auth.key";
import { ApiModules, ApiOperations, DisplayService } from '@qid/core';
import { firstValueFrom, Subject, takeUntil } from "rxjs";
import { Store } from "@ngrx/store";
import { CommonModule } from '@angular/common';
import { SexyModule } from '@qid/sexy';
import { SuperButtonComponent } from '@qid/super';
import { PermissionDirective } from '../../../organisation-user';
import { ApiCreditService } from '../../../api-credit';
import { activeAccountChanges, AuthSelectors } from '../../../authentication';


@Component({
  selector: 'app-list-auth-key',
  templateUrl: './list-auth-key-page.component.html',
  styleUrls: ['./list-auth-key-page.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    SexyModule,
    SuperButtonComponent,
    PermissionDirective,
    IonHeader,
    IonToolbar,
    IonBackButton,
    IonTitle,
    IonContent,
    IonIcon
  ]
})
export class ListAuthKeyPage implements OnInit {

  public authKeys: AuthKey[];
  public activeAccountId: string;
  public apiBalance: number = 0.00;

  constructor(
    private authKeyService: AuthKeyService,
    private modalController: ModalController,
    private displayService: DisplayService,
    private store: Store,
    private apiCreditService: ApiCreditService,
  ) {
  }

  private leave$ = new Subject<void>();

  ngOnInit() {
  }

  ionViewDidEnter() {
    this.leave$ = new Subject<void>();
    activeAccountChanges(this.store)
      .pipe(takeUntil(this.leave$))
      .subscribe((id) => {
        this.activeAccountId = id;
        this.fetchAuthKeys();
        this.fetchBalance();
      });
  }

  ionViewDidLeave() {
    this.leave$.next();
    this.leave$.complete();
  }

  fetchAuthKeys = async () => {
    const org = await firstValueFrom(this.store.select(AuthSelectors.selectActiveAccount))

    if (!org) {
      return;
    }
    const res = await this.authKeyService.readAll(org._id);
    if (!res) {
      return;
    }
    this.authKeys = res;
  };


  async createKey() {
    const activeOrg = await firstValueFrom(this.store.select(AuthSelectors.selectActiveAccount))

    const modal = await this.modalController.create({
      component: GenerateKeyComponent,
      componentProps: {
        orgId: activeOrg._id,
      },
    });
    await modal.present();
    await modal.onDidDismiss();
    await this.fetchAuthKeys();
  }


  deleteAuthKey = async (keyId) => {
    const deleteRes = await this.authKeyService.deleteKey(keyId);
    if (!deleteRes) {
      return;
    }
    await this.fetchAuthKeys();
  }

  copy(tokenId: any) {
    const el = document.createElement('textarea');
    el.value = tokenId;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    this.displayService.toast({ message: "Copied to clipboard" });
  }

  fetchBalance = async () => {

    const res = await this.apiCreditService.fetchBalance();
    if (res?.data?.balance) {
      this.apiBalance = res.data.balance;
    }
  }

  protected readonly firstValueFrom = firstValueFrom;
  protected readonly ApiOperations = ApiOperations;
  protected readonly ApiModules = ApiModules;
}
